import React from 'react'
import { Button } from '@material-ui/core'
import Close from '@material-ui/icons/Close'
import { useHistory } from 'react-router-dom'
import { analytics } from 'Modules/Analytics'
import { useAppState } from 'Context/AppContext/AppContext'
import { useStyles } from './styles'
import {
  NotificationType,
  notificationData,
  NOTIFICATION_TYPES,
} from './NotificationData'

type Props = {
  handleDismissal: (notificationType: string) => void
  notification: NotificationType
}

export const Notification = ({ handleDismissal, notification }: Props) => {
  const {
    nonprofitOrgConfig: { orgId },
    userConfig: { id: userId },
  } = useAppState()
  const noteData = notificationData[notification.type]
  const history = useHistory()
  const handleRedirect = (notificationType: string) => {
    const dispatchClicked = analytics.trackActionCreator(
      notificationData[notificationType as NOTIFICATION_TYPES].events.clicked
    )
    dispatchClicked({
      userId,
      nonprofitOrgId: orgId,
      url: window.location.href,
    })
    history.push(noteData.redirect)
  }
  const classes = useStyles()
  return (
    <div className={classes.banner}>
      {noteData.icon && <noteData.icon className={classes.icon} />}
      <div className={classes.text}>{noteData.message}</div>
      {noteData.redirect && (
        <Button
          className={classes.button}
          onClick={() => handleRedirect(notification.type)}
        >
          Update in Settings
        </Button>
      )}
      {noteData.isDismissible && (
        <Close
          className={classes.closeIcon}
          onClick={() => handleDismissal(notification.type)}
        />
      )}
    </div>
  )
}
